import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ButtonContainer = styled.button`
  display: ${props => (props.hide ? "none" : "block")};
  width: ${props => props.width};
  padding: ${props => props.padding};
  height: ${props => props.height};

  background: ${props => (props.outline ? "transparent" : props.color)};
  color: ${props => (props.outline ? props.color : "white")};
  
  border: ${props => (props.border ? props.border : `1px solid ${props.color}`)};
  border-radius: 30px;
  
  font-weight: bold;
  font-size: ${props => props.fontSize || "11px"};
  text-transform: uppercase;
  margin: ${props => props.margin ? props.margin : "0px"};

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  transition: all 0.3s;
  
  &:hover {
    cursor: pointer;
    background: ${props => props.color};
    color: #FFF;
    box-shadow: 0 0 20px 0 ${props => props.color};
  }
  &:disabled {
    cursor: auto;
    opacity: 0.5;
  }
  &:focus {
    outline: none;
  }
`;

export const ButtonContainerV2 = styled.div`
  display: ${props => props.width === 'auto' ? 'inline-block' : 'block'};
  width: ${props => props.width ? props.width : '100%'};
  height: ${props => props.height ? props.height : '100%'};
  max-width: ${props => props.maxWidth ? props.maxWidth : 'none'};
  
  margin: ${props => props.margin ? props.margin : '0px'};


  .btnv2 {
    width: ${props => props.width === 'auto' ? 'auto' : '100%'};
    height: 100%;
    padding: 12px 24px;
    white-space: ${props => props.width === 'auto' ? 'nowrap' : 'normal'};

    gap: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    outline: none;
    border-radius: 30px;
    border: ${props => (props.disabled ?  `solid 1px ${theme.colors.disabled.Fundo_Desabilitado}` : props.red === true ? `solid 1px ${theme.colors.red.Vermelho_erro}` :  props.color ? `solid 1px ${props.color}` : props.blog ? 'solid 1px #fff' : 'solid 1px #2fbb69')};
    background-color:
    ${props => (props.disabled ? theme.colors.disabled.Fundo_Desabilitado :
       props.outline ? 'transparent' :
        props.red === true ? theme.colors.red.Vermelho_erro :
         props.color ? props.color :
          props.blog ? "transparent" : '#2fbb69')};

    transition: all 0.2s;


    img.icon-default,
    img.icon-hover {
      width: 14px;
      height: auto;
    }

    img.icon-hover {
      display: none;
    }

    &:hover{
      >span{
        color: ${props => (props.disabled ? theme.colors.disabled.Desabilitado_Medio : props.blog ? theme.colors.green.Verde_AgroReceita : theme.colors.white.Branco)};
      }

      img.icon-default {
        display: none;
      }

      img.icon-hover {
        display: inline-block;
      }

      >img{
        filter: ${props => (!props.disabled && props.outline ? 'brightness(0) invert(1)' : 'none')};
      }

      svg circle, svg path {
        stroke: ${props => (props.disabled ? theme.colors.disabled.Desabilitado_Medio : props.blog ? theme.colors.green.Verde_AgroReceita : theme.colors.white.Branco)};
      }

      background-color: ${props => (props.disabled ? '#ddd' : props.red === true ? '#FF5252' : props.blog ? 'transparent' : props.color ? props.color : `${theme.colors.green.Verde_AgroReceita}`)};
      cursor: ${props => (props.disabled ? 'no-drop' :  props.loading ? 'progress' : 'pointer')};
      transform: ${props => (props.disabled ? 'none' : 'scale(1.04)')};
    }
    
    &:active {
      transform: ${props => (props.disabled ? 'none' : 'scale(0.95)')};
    }

    &:focus{
      outline: 0;
      box-shadow: none;
    }

    >img {
      width: 16px;
      height: 16px;
    }
  }


  p{
    width: auto;

    display:none;
    position:absolute;
    align-items: center;

    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    text-transform: uppercase;

    
    margin-top: 8px;
    margin-left: ${props => (props.tooltipMarginLeft ? props.tooltipMarginLeft : '122px')};
    
    padding: 3px;
    
    color:#FFF;
    background-color: ${theme.colors.gray.Cinza_1};
    opacity: 0.9;
    
    border-radius: 5px;

    &:before{
        position: absolute;
        background-color:  ${theme.colors.gray.Cinza_1};
        width: 8px;
        height: 8px;
        top: -4px;
        margin-left: 17px;
        content: '';
        transform: rotate(45deg);
    }

}

&:hover{
    text-decoration: none;
    p{
        display: block;
    }
}

`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: ${props => (props.loaderColor ? `1px solid ${props.loaderColor}` : props.disabled ? '1px solid #999' : props.outline ? props.red === true ? `1px solid ${theme.colors.red.Vermelho_erro}` : `1px solid ${theme.colors.green.Bandeira}` : '1px solid #FFF')};
  border-bottom: ${props => (props.loaderColor ? `1px solid ${props.loaderColor}` : props.disabled ? '1px solid #999' : props.outline ? props.red === true ? `1px solid ${theme.colors.red.Vermelho_erro}` : `1px solid ${theme.colors.green.Bandeira}` : '1px solid #FFF')};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;
